const { Type } = require('@sinclair/typebox');

/** Builds the TypeBox schema fragment for the DatePicker form element. */
function asDataDictionary(hNode, context) {
    const { id, title, propertyName, required, format } = hNode;
    //This block tells us nothing about namespaces/relations
    const subDataDictionary = {};

    // Determine optional/editable flags based on the context (readOnly) and the required flag.
    let optional;
    let editable;
    if (!context?.readOnly) {
        editable = true;
        if (!required) {
            optional = true;
        }
    }

    // Helper to wrap a schema as optional if needed
    const maybeOptional = (schema) => (optional ? Type.Optional(schema) : schema);

    // Build the string schema with date/time format
    const stringOptions = {
        title: title,
        format: 'date-time',
        'x-id': id,
        'x-dataType': 'string',
        'x-propertyName': propertyName,
        'x-optional': !!optional,
        'x-editable': !!editable,
        'x-displayFormat': format
    };

    const datePickerSchema = maybeOptional(Type.String(stringOptions));

    // The partial type definition is a plain object with the property schema
    const partialTypeDefinition = {
        [propertyName]: datePickerSchema
    };

    return [subDataDictionary, partialTypeDefinition];
}

module.exports = { asDataDictionary };
